// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { ClientModel } from '../../symbols';

export interface ClientListStateModel {
  clientList: PaginatorModel<ClientModel>,
  loadClientListStatus: PROGRESS_STATUSES,
  lastOpenedDocId: string,
  scrollPosition: number
}

export const CLIENT_LIST_STATE_DEFAULT: ClientListStateModel = {
  clientList: {
    data: [],
    links: null,
    meta: null
  },
  lastOpenedDocId: null,
  scrollPosition: 0,
  loadClientListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
